import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_BASE } from '../constants/checkout';
export function StickyBuyBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 900);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-181" data-mp="3hdiwdd537qqb">
      {visible ? <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 320,
      damping: 32
    }} className="fixed bottom-0 left-0 right-0 z-50 border-t border-ink-700 bg-ink-950/95 backdrop-blur lg:hidden" data-id="element-182" data-mp="3hgn76td25kpy">
          <div className="mx-auto flex w-full max-w-page items-center gap-4 px-4 py-3" data-id="element-183" data-mp="1w20zla5i1cbf">
            <div className="min-w-0" data-id="element-184" data-mp="29f9dt4g7d5nu">
              <p className="display truncate text-sm text-bone" data-id="element-185" data-mp="29gapnb51lw6m">Pack Blanco Perfecto</p>
              <p className="text-xs font-semibold text-ash" data-id="element-186" data-mp="2eevnj3wto3rw">
                <span className="line-through" data-id="element-187" data-mp="2ifo1ubkjwyv1">$38.000</span>{' '}
                <span className="text-bone" data-id="element-188" data-mp="2ie4gi6k1fxme">$19.990 ARS</span>
              </p>
            </div>
            <a href={CHECKOUT_BASE} className="display ml-auto inline-flex shrink-0 items-center gap-2 bg-bone px-4 py-3 text-sm text-ink-950 transition-colors hover:bg-ice" data-id="element-189" data-mp="2n7fi9t9zto7g">
              Comprar
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-190" data-mp="323ogqsm27xit" />
            </a>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}